import React, { Component, ChangeEvent, FC } from "react";
import { Link } from "react-router-dom"; // Importez le composant Link
import CadreDesoummissions from "./Cadre2";
import ControlFormular from "./control";
import BlocageFormular from "./blocage";
import UnclearFormular from "./unclear";
import SubmissionList2 from "./submissionList2";

interface SubmissionsProps {
  gotoControlForm: () => void;
  gotoUnclearForm: () => void;
  gotoBlocageForm: () => void;
  handleChange: (value: string) => void;
  values: any; // Remplacez 'any' par le type approprié pour 'values'
}

const Submissions: FC<SubmissionsProps> = ({
  gotoControlForm,
  gotoBlocageForm,
  gotoUnclearForm,
  handleChange,
  values,
}) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="text-1xl font-bold text-[#858585] ml-4">
        Soumettre un nouvel exercice
      </div>
      <div className="flex flex-row overflow-x-auto lg:overflow-visible p-4 space-x-4 lg:space-x-10 justify-start lg:justify-between">
        <Link
          to=""
          onClick={gotoControlForm}
          className="flex-shrink-0 lg:flex-shrink"
        >
          <CadreDesoummissions
            couleur="bg-[#5B7582]"
            titre="Contrôle et validation"
            sousTitre="Vous venez de traiter un exercice ou une épreuve ? Faites vérifier vos réponses par un enseignant en cliquant ici.
"
            // onPrev={onPrev}
            // onNext={onNext}
            // handleChange={handleChange}
            // values={values}
          />
        </Link>
        <Link
          to=""
          onClick={gotoUnclearForm}
          className="flex-shrink-0 lg:flex-shrink"
        >
          <CadreDesoummissions
            couleur="bg-[#7F544E]"
            titre="Mauvaise compréhension"
            sousTitre="Vous n’arrivez pas à comprendre l’énoncé ou à démarrer avec la première question ? Obtenez maintenant de l'aide de la part d'un enseignant en cliquant ici."
          />
        </Link>
        <Link
          to=""
          onClick={gotoBlocageForm}
          className="flex-shrink-0 lg:flex-shrink"
        >
          <CadreDesoummissions
            couleur="bg-[#6B4B3B]"
            titre="Blocage"
            sousTitre="Vous avez démarré votre exercice ou votre épreuve mais vous restez bloqué sur une question ? Faites vous débloquer maintenant par un enseignant en cliquant ici."
          />
        </Link>
      </div>
      <SubmissionList2 />
    </div>
  );
};

//export default Submissions;

interface State {
  step: number;
  [key: string]: any;
  // Ajoutez ici les autres champs de votre état
}

class SubmissionsMultiStep extends Component<{}, State> {
  state: State = {
    step: 1,
    // Initialisez ici les autres champs de votre état
  };

  // Revenir à l'étape précédente
  prevStep = () => {
    const { step } = this.state;
    this.setState({ step: step - 1 });
  };

  // Passer à l'étape suivante
  nextStep = () => {
    const { step } = this.state;
    this.setState({ step: step + 1 });
  };

  // Gérer le changement des champs
  handleChange =
    (input: string) =>
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      this.setState({ [input]: e.target.value });
      // console.log(this.state[input]);
    };

  render() {
    const { step } = this.state;
    // Ajoutez ici les autres champs de votre état

    switch (step) {
      case 1:
        return (
          <Submissions
            gotoControlForm={() => {
              this.setState({ step: 2 });
            }}
            gotoUnclearForm={() => {
              this.setState({ step: 4 });
            }}
            gotoBlocageForm={() => {
              this.setState({ step: 3 });
            }}
            handleChange={() => {}}
            values={undefined}
          />
        );

      case 2:
        return (
          <ControlFormular
            onCancel={() => this.setState({ step: 1 })}
            onSuccess={() => this.setState({ step: 1 })}
          />
        );

      case 3:
        return (
          <BlocageFormular
            onCancel={() => this.setState({ step: 1 })}
            onSuccess={() => this.setState({ step: 1 })}
          />
        );
      case 4:
        return (
          <UnclearFormular
            onCancel={() => this.setState({ step: 1 })}
            onSuccess={() => this.setState({ step: 1 })}
          />
        );
      default:
    }
  }
}

export default SubmissionsMultiStep;
